(() => {
  'use strict';
  const ready = new WeakSet();
  const focusable = 'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const initialize = root => {
    if (ready.has(root)) return;
    ready.add(root);
    const dialog = root.querySelector('[data-qrf-dialog]');
    const dialogImage = dialog?.querySelector('[data-qrf-dialog-image]');
    const dialogTitle = dialog?.querySelector('[data-qrf-dialog-title]');
    const dialogCaption = dialog?.querySelector('[data-qrf-dialog-caption]');
    const dialogClose = dialog?.querySelector('[data-qrf-dialog-close]');
    const syncGalleryPreview = (gallery, panel) => {
      const selected = panel?.querySelector('[data-qrf-preview]');
      const enlarge = gallery.querySelector('[data-qrf-gallery-enlarge]');
      if (!selected || !enlarge) return;
      ['previewImage', 'previewTitle', 'previewCaption', 'previewAlt'].forEach(key => {
        enlarge.dataset[key] = selected.dataset[key] || '';
      });
      enlarge.setAttribute('aria-label', selected.getAttribute('aria-label') || 'Enlarge image');
    };
    root.querySelectorAll('[data-qrf-gallery]').forEach(gallery => {
      const panel = [...gallery.querySelectorAll('[data-qrf-gallery-panel]')].find(item => !item.hidden);
      syncGalleryPreview(gallery, panel);
    });
    let opener;
    const openPreview = button => {
      if (!dialog || typeof dialog.showModal !== 'function' || !button.dataset.previewImage) return;
      opener = button;
      dialogImage.src = button.dataset.previewImage;
      dialogImage.alt = button.dataset.previewAlt || button.dataset.previewTitle || '';
      dialogImage.removeAttribute('width');
      dialogImage.removeAttribute('height');
      dialogTitle.textContent = button.dataset.previewTitle || '';
      dialogCaption.textContent = button.dataset.previewCaption || '';
      dialog.showModal();
      dialogClose.focus({preventScroll: true});
    };
    root.addEventListener('click', event => {
      const preview = event.target.closest('[data-qrf-preview]');
      if (preview && root.contains(preview)) openPreview(preview);
      const close = event.target.closest('[data-qrf-dialog-close]');
      if (close && dialog?.open) dialog.close();
      const galleryButton = event.target.closest('[data-qrf-gallery-button]');
      if (galleryButton) {
        const gallery = galleryButton.closest('[data-qrf-gallery]');
        if (!gallery) return;
        const name = galleryButton.dataset.qrfGalleryButton;
        let selectedPanel;
        gallery.querySelectorAll('[data-qrf-gallery-panel]').forEach(panel => {
          panel.hidden = panel.dataset.qrfGalleryPanel !== name;
          if (!panel.hidden) selectedPanel = panel;
        });
        gallery.querySelectorAll('[data-qrf-gallery-button]').forEach(button => {
          button.setAttribute('aria-pressed', String(button === galleryButton));
        });
        syncGalleryPreview(gallery, selectedPanel);
      }
    });
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog?.addEventListener('close', () => {
      if (opener?.isConnected) opener.focus({preventScroll: true});
    });
    dialog?.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll(focusable)].filter(element => element.getClientRects().length > 0 && !element.closest('[hidden]'));
      if (!items.length) { event.preventDefault(); dialog.focus(); return; }
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    const sample = root.querySelector('[data-qrf-sample]');
    if (sample) {
      const guesses = [...sample.querySelectorAll('input[type="radio"]')];
      const reveal = sample.querySelector('[data-qrf-reveal]');
      const reset = sample.querySelector('[data-qrf-reset]');
      const status = sample.querySelector('[data-qrf-sample-status]');
      const slots = [...sample.querySelectorAll('[data-qrf-answer]')];
      let selected = '';
      guesses.forEach(input => input.addEventListener('change', () => {
        selected = input.value;
        reveal.disabled = false;
        status.textContent = `Your team's guess is ${selected}. Reveal the answers when you are ready.`;
      }));
      reveal.addEventListener('click', () => {
        if (!selected) return;
        slots.forEach(slot => {
          slot.querySelector('[data-qrf-answer-hidden]').hidden = true;
          slot.querySelector('[data-qrf-answer-shown]').hidden = false;
          slot.toggleAttribute('data-selected', slot.dataset.qrfAnswer === selected);
        });
        guesses.forEach(input => { input.disabled = true; });
        reveal.hidden = true;
        reset.hidden = false;
        const points = {'K.I.T.T.': 3, 'Batmobile': 2, 'Herbie the Love Bug': 1}[selected] || 0;
        status.textContent = `You picked ${selected}, worth ${points} ${points === 1 ? 'point' : 'points'}. Kit 1 answers: K.I.T.T., 3 points; Batmobile, 2 points; Herbie the Love Bug, 1 point.`;
        reset.focus({preventScroll: true});
      });
      reset.addEventListener('click', () => {
        selected = '';
        slots.forEach(slot => {
          slot.querySelector('[data-qrf-answer-hidden]').hidden = false;
          slot.querySelector('[data-qrf-answer-shown]').hidden = true;
          slot.removeAttribute('data-selected');
        });
        guesses.forEach(input => { input.disabled = false; input.checked = false; });
        reset.hidden = true;
        reveal.hidden = false;
        reveal.disabled = true;
        status.textContent = 'Sample reset. Choose another guess to reveal the answers again.';
        guesses[0].focus({preventScroll: true});
      });
    }
    const bar = root.querySelector('[data-qrf-mobile-bar]');
    const purchase = root.querySelector('[data-qrf-purchase]');
    const bottom = root.querySelector('[data-qrf-bottom]');
    if (bar && purchase && bottom && 'IntersectionObserver' in window) {
      let rootVisible = false;
      let purchaseVisible = false;
      let bottomVisible = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === root) rootVisible = entry.isIntersecting;
          if (entry.target === purchase) purchaseVisible = entry.isIntersecting;
          if (entry.target === bottom) bottomVisible = entry.isIntersecting;
        });
        bar.hidden = !rootVisible || purchaseVisible || bottomVisible;
      });
      [root, purchase, bottom].forEach(target => observer.observe(target));
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, {once: true});
    }
  };
  const discover = () => document.querySelectorAll('[data-qrf-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, {once: true});
  else discover();
  document.addEventListener('shopify:section:load', discover);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-qrf-root]') || node.querySelector('[data-qrf-root]'))))) discover();
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
